import Select from "react-select";
import {useQuery} from "react-query";
import React, {useEffect, useState} from "react";
import {getActivityAttributes, getAllActivities} from "Api/Query/ActivityQuery";
import {SelectOptionType} from "Model/Select/SelectOption";

interface Props {
    onChange: (newValue: SelectOptionType|null) => void,
    onEntitiesLoad?: (activities: any[]) => void,
    value?: any,
    classes?: string
}

export const ActivityAttributesSelect : React.FC<Props> = (props) => {

    const [options, setOptions] = useState<any>([])

    const activityAttributesQuery = useQuery({
        enabled: false,
        queryKey: ['getActivityAttributes'],
        queryFn: () => getActivityAttributes(),
        onSuccess: (response: any) => {
            const attributes : object[] = []
            response.data._result.items.map((item:any) => {
                attributes.push({
                    label: item.name,
                    value: item.id
                })
            })
            setOptions(attributes)

            if(props.onEntitiesLoad){
                props.onEntitiesLoad(response.data._result.items)
            }
        }
    })

    useEffect(() => {
        activityAttributesQuery.refetch()
    }, [])

    return (
        <Select
            value={props.value ?? null}
            // isLoading={isLoading}
            options={options}
            placeholder={""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            onChange={props.onChange}
            className={props.classes ?? ''}
        />
    )
}
